export enum ObjectType {
  DOCUMENT = 'DOCUMENT',
  TASK = 'TASK',
  DRAFT = 'DRAFT',
  ENTITY = 'ENTITY'
}
